import { initializeApp, getApps } from 'firebase/app'
import { isHaikuHost } from '@/util/enterprise'

const isHaiku = isHaikuHost()

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: isHaiku ? import.meta.env.VITE_FIREBASE_HAIKU_AUTH_DOMAIN : import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Initialize Firebase if not already initialized
const firebase_app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]

export default firebase_app
